import Vue from 'vue'
import Router from './Router'
import { parseFieldScan } from './utils/helpers'
function initSelected() {
	var stored = localStorage.getItem('selectedWorkerIds')
	if (stored == null) {
		return []
	}

	var parsedArray = JSON.parse(stored)
	return parsedArray
}

export default {
	namespaced: true,
	state: {
		workers: [],
		meta: null,
		loading: true,
		workerDetail: {},
		preview: {},
		finance: [],
		comments: [],
		history: [],
		isLoadingCreateWorker: false,
		isLoadingDetail: false,
		datesFinance: {
			date_start: null,
			date_end: null
		},
		financeFile: new ArrayBuffer(),
		workersFile: new ArrayBuffer(),
		isDownloadReport: false,
		lastHourlyRate: 0,
		selectedWorkerIds: initSelected()
	},
	actions: {
		async fetch({ commit }, query) {
			commit('setList', { meta: null, data: [] })
			const response = await Vue.http.get('workers', { params: query })
			commit('setList', response.body)
		},
		async fetchOne({ commit, dispatch, rootState }) {
			try {
				dispatch('fetchPreview')
				commit('setLoadingDetail', true)
				const id = rootState.route.params.workerId
				const response = await Vue.http.get('workers/' + id)
				commit('setOne', response.body)
				commit('setLoadingDetail', false)
				return response
			} catch (e) {
				commit('setLoadingDetail', false)
			}
		},
		async fetchPreview({ commit, rootState }) {
			const id = rootState.route.params.workerId
			const response = await Vue.http.get(`workers/${id}/preview`)
			commit('sePreview', response.body)
			return response
		},
		async createWorker({ commit }, data) {
			try {
				commit('setLoadCreateWorker', true)
				const response = await Vue.http.post(`workers`, data)
				Router.push(`workers/${response.body.id}`)
				commit('setLoadCreateWorker', false)
			} catch (e) {
				commit('setLoadCreateWorker', false)
				console.error(e)
			}
		},
		async updateWorker({ commit, rootState, dispatch }) {
			const id = rootState.route.params.workerId
			const { workerDetail } = rootState.workers
			const response = await Vue.http.post(`workers/${id}`, workerDetail)
			commit('setOne', response.body)
			dispatch('fetchPreview')
		},
		async deleteWorker({ commit, dispatch }, workerId) {
			await Vue.http.delete(`workers/${workerId}`)
			dispatch('fetch')
		},

		async deleteScan({ commit, rootState, dispatch }, scanId) {
			const id = rootState.route.params.workerId
			await Vue.http.delete(`workers/${id}/scans/${scanId}`)
			dispatch('fetchOne')
		},
		async updateScan({ commit, rootState, dispatch }, dataScan) {
			await Vue.http.post(`scans/${dataScan.id}`, parseFieldScan(dataScan))
			dispatch('fetchOne')
		},
		async getFinance({ commit, rootState, state }) {
			const id = rootState.route.params.workerId
			const query = {}
			state.datesFinance.date_start ? query.date_start = state.datesFinance.date_start : ''
			state.datesFinance.date_end ? query.date_end = state.datesFinance.date_end : ''
			const response = await Vue.http.get(
				`workers/${id}/pays`, { params: query })
			commit('setFinance', response.body)
		},

		async paySalary({ commit, rootState, dispatch }, data) {
			const id = rootState.route.params.workerId
			await Vue.http.post(`workers/${id}/pay/salary`, data)
			dispatch('getFinance')
		},
		async makePrepay({ commit, rootState, dispatch }, data) {
			const id = rootState.route.params.workerId
			await Vue.http.post(`workers/${id}/pay/prepay`, data)
			dispatch('getFinance')
		},
		async getLastHourlyRate({ commit, rootState }) {
			const id = rootState.route.params.workerId
			let response = await Vue.http.get(`workers/${id}/pay/last-hourly-rate`)
			commit('setLastHourlyRate', response.body)
		},
		async deletePay({ commit }, payId) {
			await Vue.http.delete(`pays/${payId}`)
		},

		async createJob({ commit, rootState, dispatch }, data) {
			const id = rootState.route.params.workerId
			await Vue.http.post(`workers/${id}/jobs`, data)
			dispatch('fetchOne')
		},
		async updateJob({ commit, dispatch }, data) {
			await Vue.http.post(`jobs/${data.id}`, data)
			dispatch('fetchOne')
		},
		async deleteJob({ commit, dispatch }, jobId) {
			await Vue.http.delete(`jobs/${jobId}`)
			dispatch('fetchOne')
		},

		async getComments({ commit, dispatch, rootState }) {
			const id = rootState.route.params.workerId
			const response = await Vue.http.get(`workers/${id}/comments`)
			commit('setComments', response.body)
		},
		async createComment({ commit, dispatch, rootState }, comment) {
			const id = rootState.route.params.workerId
			await Vue.http.post(`workers/${id}/comments`, comment)
			dispatch('getComments')
		},
		async deleteComment({ commit, dispatch, rootState }, commnetId) {
			const id = rootState.route.params.workerId
			await Vue.http.delete(`workers/${id}/comments?comment_id=${commnetId}`)
			dispatch('getComments')
		},

		async getHistory({ commit, dispatch, rootState }) {
			const id = rootState.route.params.workerId
			const response = await Vue.http.get(`workers/${id}/history`)
			commit('setHistory', response.body)
		},

		async createAddress({ rootState, commit }, data) {
			const id = rootState.route.params.workerId
			let response = await Vue.http.post(`addresses`, { ...data, addressable_id: id })
			data.id = response.body.addressId
			commit('addAddress', data)
		},
		async updateAddress({ commit }, data) {
			await Vue.http.post(`addresses/${data.id}`, data)
			commit('updateAddress', data)
		},
		async deleteAddress({ commit }, id) {
			await Vue.http.delete(`addresses/${id}`)
			commit('deleteAddress', id)
		},

		async createAccommodation({ rootState, dispatch }, data) {
			const id = rootState.route.params.workerId
			await Vue.http.post(`workers/${id}/accommodations`, data)
			dispatch('fetchOne')
		},
		async updateAccommodation({ dispatch }, data) {
			await Vue.http.post(`accommodations/${data.id}`, data)
			dispatch('fetchOne')
		},
		async deleteAccommodation({ dispatch }, id) {
			await Vue.http.delete(`accommodations/${id}`)
			dispatch('fetchOne')
		},

		async deleteAvatar({ commit, dispatch, rootState }) {
			const id = rootState.route.params.workerId
			await Vue.http.delete(`workers/${id}/delete-avatar`)
			commit('setAvatar', null)
		},

		async exportWorkers({ commit }, query) {
			try {
				commit('setDownloadingReport', true)
				const response = await Vue.http.get('workers/export', { params: query, responseType: 'arraybuffer' })
				commit('setWorkersFile', response.body)
				commit('setDownloadingReport', false)
			} catch (e) {
				commit('setDownloadingReport', false)
			}
		},
		async setSelectState({ commit, state }, { workerId, value }) {
			let newArray = [...state.selectedWorkerIds]
			if (value) {
				newArray.push(workerId)
			} else {
				newArray = newArray.filter(item => item !== workerId)
			}
			localStorage.setItem('selectedWorkerIds', JSON.stringify(newArray));
			commit("setSelectedWorkerIds", newArray)
		},
		async clearSelected({ commit}) {
			localStorage.removeItem('selectedWorkerIds');
			commit("setSelectedWorkerIds", [])
		}
	},
	mutations: {
		setSelectedWorkerIds(state, value) {
			state.selectedWorkerIds = value
		},
		setList(state, workers) {
			state.workers = workers.data
			state.meta = workers.meta
			state.loading = false
		},
		setOne(state, workerDetail) {
			state.workerDetail = { ...workerDetail }
		},
		setFinance(state, finance) {
			state.finance = finance
		},
		setLastHourlyRate(state, hourlyRate) {
			state.lastHourlyRate = hourlyRate
		},

		addContact(state, contact) {
			state.workerDetail.contacts = state.workerDetail.contacts
				? [...state.workerDetail.contacts, contact]
				: [contact]
		},
		deleteContact(state, contact) {
			state.workerDetail.contacts = state.workerDetail.contacts.filter(
				item => item.name + item.value !== contact.name + contact.value
			)
		},
		setComments(state, comments) {
			state.comments = comments
		},
		setLoadingDetail(state, status) {
			state.isLoadingDetail = status
		},
		setHistory(state, history) {
			state.history = history
		},
		setLoadCreateWorker(state, status) {
			state.isLoadingCreateWorker = status
		},
		setAvatar(state, avatar) {
			state.workerDetail.avatar = avatar
		},
		setFinanceFile(state, file) {
			state.financeFile = file
		},
		setDownloadingReport(state, status) {
			state.isDownloadReport = status
		},
		sePreview(state, data) {
			state.preview = data
		},

		setWorkersFile(state, file) {
			state.workersFile = file
		},

		addAddress(state, address) {
			state.workerDetail.worker_home_address = state.workerDetail.worker_home_address
				? [...state.workerDetail.worker_home_address, address]
				: [address]
		},
		updateAddress(state, address) {
			state.workerDetail.worker_home_address = state.workerDetail.worker_home_address.map(
				item => {
					return item.id === address.id ? address : item
				}
			)
		},
		deleteAddress(state, addressId) {
			state.workerDetail.worker_home_address = state.workerDetail.worker_home_address.filter(
				item => item.id !== addressId
			)
		}
	}
}
